// extracted by mini-css-extract-plugin
export default {"item":"ProductPropertiesList__item___pliaP"};